import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TranslateModule} from '@ngx-translate/core';

import {LaddingPageComponent} from "./LaddingPage.component";
import {RecuperarPasswordComponent} from './RecuperarPassword/RecuperarPassword.component';
import {SeguridadService} from '../../Servicios/Seguridad.service';


export const routes =
  [
    { path: '',  component: LaddingPageComponent, data: {modulo:'sesion'},  canActivate: [SeguridadService]},
    { path: '**', redirectTo: '', pathMatch: 'full'},
  ];

@NgModule(
  {
    declarations:
    [
      LaddingPageComponent,
      RecuperarPasswordComponent
    ],
    imports:
    [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule.forChild(routes),
      ModalModule.forRoot(),
      AngularSvgIconModule,
      TranslateModule
    ]
  })

export class LaddingPageModule
{
  static routes = routes;
}

